export default "__VITE_ASSET__BgX6LbX7__"